"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningStargateClient = void 0;
var encoding_1 = require("@cosmjs/encoding");
var encoding_2 = require("@cosmjs/encoding");
var proto_signing_1 = require("@cosmjs/proto-signing");
var tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
var signing_1 = require("cosmjs-types/cosmos/tx/signing/v1beta1/signing");
var tx_1 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
var accounts_1 = require("./accounts");
var stargateclient_1 = require("./stargateclient");
var axios_1 = __importDefault(require("axios"));
var math_1 = require("@cosmjs/math");
var any_1 = require("../google/protobuf/any");
var long_1 = __importDefault(require("long"));
var encoding_3 = require("../amino/encoding");
var SigningStargateClient = /** @class */ (function (_super) {
    __extends(SigningStargateClient, _super);
    function SigningStargateClient(tmClient, signer, registry) {
        var _this = _super.call(this, tmClient) || this;
        _this.registry = registry;
        _this.signer = signer;
        return _this;
    }
    SigningStargateClient.prototype.getSigner = function () {
        return this.signer;
    };
    SigningStargateClient.connectWithSigner = function (endpoint, signer, registry) {
        return __awaiter(this, void 0, void 0, function () {
            var tmClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._endpoint = endpoint;
                        return [4 /*yield*/, tendermint_rpc_1.Tendermint34Client.connect(endpoint)];
                    case 1:
                        tmClient = _a.sent();
                        return [2 /*return*/, new SigningStargateClient(tmClient, signer, registry)];
                }
            });
        });
    };
    SigningStargateClient.prototype.signAndBroadcast = function (signerAddress, messages, fee, memo) {
        if (memo === void 0) { memo = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sign(signerAddress, messages, fee, memo)];
                    case 1:
                        txRaw = _a.sent();
                        txBytes = tx_1.TxRaw.encode(txRaw).finish();
                        return [2 /*return*/, this.broadcastTx(txBytes)];
                }
            });
        });
    };
    SigningStargateClient.makeSignDocForSend = function (signerAddress, pubkeyStr, messages, fee, memo, serverUrl, chainId, registry) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accountNumber, sequence, account, rawSecp256k1Pubkey, pubkey, txBodyEncodeObject, txBodyBytes, gasLimit, authInfoBytes;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        SigningStargateClient._endpoint = serverUrl;
                        return [4 /*yield*/, SigningStargateClient.getSequence(signerAddress)];
                    case 1:
                        _a = _b.sent(), accountNumber = _a.accountNumber, sequence = _a.sequence;
                        return [4 /*yield*/, SigningStargateClient.getAccount(signerAddress)];
                    case 2:
                        account = _b.sent();
                        if (account == null)
                            throw new Error("Failed to retrieve account from signer");
                        rawSecp256k1Pubkey = encoding_1.fromBase64(pubkeyStr);
                        pubkey = proto_signing_1.encodePubkey(encoding_3.encodeSecp256k1Pubkey(rawSecp256k1Pubkey));
                        txBodyEncodeObject = {
                            typeUrl: "/cosmos.tx.v1beta1.TxBody",
                            value: {
                                messages: messages,
                                memo: memo,
                            },
                        };
                        txBodyBytes = registry.encode(txBodyEncodeObject);
                        gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
                        authInfoBytes = this.makeAuthInfoBytes([{ pubkey: pubkey, sequence: sequence }], fee.amount, gasLimit, fee.granter);
                        return [2 /*return*/, proto_signing_1.makeSignDoc(txBodyBytes, authInfoBytes, chainId, accountNumber)];
                }
            });
        });
    };
    SigningStargateClient.prototype.sign = function (signerAddress, messages, fee, memo, explicitSignerData) {
        return __awaiter(this, void 0, void 0, function () {
            var signerData, _a, accountNumber, sequence, chainId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!explicitSignerData) return [3 /*break*/, 1];
                        signerData = explicitSignerData;
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, SigningStargateClient.getSequence(signerAddress)];
                    case 2:
                        _a = _b.sent(), accountNumber = _a.accountNumber, sequence = _a.sequence;
                        return [4 /*yield*/, this.getChainId()];
                    case 3:
                        chainId = _b.sent();
                        signerData = {
                            accountNumber: accountNumber,
                            sequence: sequence,
                            chainId: chainId,
                        };
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.signDirect(signerAddress, messages, fee, memo, signerData)];
                }
            });
        });
    };
    SigningStargateClient.prototype.getChainId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, chainId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.chainId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.forceGetTmClient().status()];
                    case 1:
                        response = _a.sent();
                        chainId = response.nodeInfo.network;
                        if (!chainId)
                            throw new Error("Chain ID must not be empty");
                        this.chainId = chainId;
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.chainId];
                }
            });
        });
    };
    /**
   * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
   * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
   * The result is typically 20 bytes long but not restricted to that.
   */
    SigningStargateClient.toAccAddress = function (address) {
        return encoding_2.Bech32.decode(address).data;
    };
    SigningStargateClient.getAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var accAddress, hexAccAddress, axios, path, result, finalData, account, finalAccount, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        accAddress = this.toAccAddress(address);
                        hexAccAddress = "0x01" + Buffer.from(accAddress).toString("hex");
                        axios = axios_1.default.create({
                            baseURL: SigningStargateClient._endpoint,
                            headers: {
                                Accept: "application/json",
                            },
                            timeout: 15000
                        });
                        path = "/abci_query?path=\"/store/acc/key\"";
                        return [4 /*yield*/, axios.get(path, { params: { data: hexAccAddress } })];
                    case 1:
                        result = _a.sent();
                        finalData = result.data.result.response.value;
                        account = any_1.Any.decode(Buffer.from(finalData, "base64"));
                        finalAccount = accounts_1.accountFromAny(account);
                        return [2 /*return*/, finalAccount];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SigningStargateClient.getSequence = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccount(address)];
                    case 1:
                        account = _a.sent();
                        if (!account) {
                            throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
                        }
                        return [2 /*return*/, {
                                accountNumber: account.accountNumber,
                                sequence: account.sequence,
                            }];
                }
            });
        });
    };
    SigningStargateClient.makeSignerInfos = function (signers, signMode) {
        return signers.map(function (_a) {
            var pubkey = _a.pubkey, sequence = _a.sequence;
            return ({
                publicKey: pubkey,
                modeInfo: {
                    single: { mode: signMode },
                },
                sequence: long_1.default.fromNumber(sequence),
            });
        });
    };
    SigningStargateClient.makeAuthInfoBytes = function (signers, feeAmount, gasLimit, granter, signMode) {
        if (signMode === void 0) { signMode = signing_1.SignMode.SIGN_MODE_DIRECT; }
        var authInfo = {
            signerInfos: this.makeSignerInfos(signers, signMode),
            fee: {
                amount: __spreadArray([], __read(feeAmount)),
                gasLimit: long_1.default.fromNumber(gasLimit),
                granter: granter,
            },
        };
        return tx_1.AuthInfo.encode(tx_1.AuthInfo.fromPartial(authInfo)).finish();
    };
    SigningStargateClient.prototype.signDirect = function (signerAddress, messages, fee, memo, _a) {
        var accountNumber = _a.accountNumber, sequence = _a.sequence, chainId = _a.chainId;
        return __awaiter(this, void 0, void 0, function () {
            var accountFromSigner, pubkey, txBodyEncodeObject, txBodyBytes, gasLimit, authInfoBytes, signDoc, _b, signature, signed;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getSigner().getAccounts()];
                    case 1:
                        accountFromSigner = (_c.sent()).find(function (account) { return account.address === signerAddress; });
                        if (!accountFromSigner) {
                            throw new Error("Failed to retrieve account from signer");
                        }
                        pubkey = proto_signing_1.encodePubkey(encoding_3.encodeSecp256k1Pubkey(accountFromSigner.pubkey));
                        txBodyEncodeObject = {
                            typeUrl: "/cosmos.tx.v1beta1.TxBody",
                            value: {
                                messages: messages,
                                memo: memo,
                            },
                        };
                        txBodyBytes = this.registry.encode(txBodyEncodeObject);
                        gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
                        authInfoBytes = SigningStargateClient.makeAuthInfoBytes([{ pubkey: pubkey, sequence: sequence }], fee.amount, gasLimit, fee.granter);
                        signDoc = proto_signing_1.makeSignDoc(txBodyBytes, authInfoBytes, chainId, accountNumber);
                        return [4 /*yield*/, this.getSigner().signDirect(signerAddress, signDoc)];
                    case 2:
                        _b = _c.sent(), signature = _b.signature, signed = _b.signed;
                        return [2 /*return*/, tx_1.TxRaw.fromPartial({
                                bodyBytes: signed.bodyBytes,
                                authInfoBytes: signed.authInfoBytes,
                                signatures: [encoding_1.fromBase64(signature.signature)],
                            })];
                }
            });
        });
    };
    SigningStargateClient.prototype.signDirectForSignDoc = function (signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function () {
            var accountFromSigner, _a, signature, signed, txRaw;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getSigner().getAccounts()];
                    case 1:
                        accountFromSigner = (_b.sent()).find(function (account) { return account.address === signerAddress; });
                        if (!accountFromSigner) {
                            throw new Error("Failed to retrieve account from signer");
                        }
                        return [4 /*yield*/, this.getSigner().signDirect(signerAddress, signDoc)];
                    case 2:
                        _a = _b.sent(), signature = _a.signature, signed = _a.signed;
                        txRaw = tx_1.TxRaw.fromPartial({
                            bodyBytes: signed.bodyBytes,
                            authInfoBytes: signed.authInfoBytes,
                            signatures: [encoding_1.fromBase64(signature.signature)],
                        });
                        return [2 /*return*/, { txRaw: txRaw, signature: signature.signature }];
                }
            });
        });
    };
    SigningStargateClient._endpoint = "";
    return SigningStargateClient;
}(stargateclient_1.StargateClient));
exports.SigningStargateClient = SigningStargateClient;
